import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=a222c7c2&scoped=true&"
import script from "./PlayerDetail.vue?vue&type=script&lang=js&"
export * from "./PlayerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDetail.vue?vue&type=style&index=0&id=a222c7c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a222c7c2",
  null
  
)

export default component.exports